import { User } from "oidc-client-ts";

const onSigninCallback = (_user: User | void): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

const oidcConfig = {
  scope: "openid apst_controlling",
  response_type: "code",
  automaticSilentRenew: true,
  token_type: "Bearer",
  onSigninCallback,
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENTID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URL,
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_URL,
  // silent_redirect_uri:
  //   process.env.REACT_APP_API_ENDPOINT + "/silent-redirect.html",
};
export default oidcConfig;
